import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput, Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // for dateClick

@Component({
  selector: 'prada-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit, AfterViewInit {
  @Input()
  events: EventInput[];

  @Output()
  eventClick: EventEmitter<any> = new EventEmitter();

  @Output() dateChange: EventEmitter<Date> = new EventEmitter();

  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  @ViewChild('next') nextButton: any;

  calendarApi: Calendar;
  calendarPlugins = [dayGridPlugin, interactionPlugin];
  views: any = {};
  calendarButtons = {
    prevButton: {
      icon: 'fc-icon-chevron-left',
      click: () => {
        this.calendarApi.prev();
        this.dateChange.emit(this.calendarApi.getDate());
      },
    },
    nextButton: {
      icon: 'fc-icon-chevron-right',
      click: () => {
        this.calendarApi.next();
        this.dateChange.emit(this.calendarApi.getDate());
      },
    },
  };
  calendarHeader = {
    left: '',
    center: 'prevButton,title,nextButton',
    right: '',
  };

  constructor() {}

  ngOnInit() {
    this.views = {
      dayGrid: {
        eventLimit: 6,
      },
    };
  }

  ngAfterViewInit() {
    this.calendarApi = this.calendarComponent.getApi();
  }

  onEventClick(item) {
    this.eventClick.emit(item.event);
  }
}
